import { Group, Skeleton, Text } from '@mantine/core';
import { useIdentity } from '../hooks/useIdentity';

/**
 * Right-side identity widget for the app shell header. UX only — audit logs
 * come from the server-side verified Cloudflare Access JWT, not this label.
 */
export const SignedInIdentity = (): React.JSX.Element => {
    const { data: identity, isLoading } = useIdentity();

    return (
        <Group gap="xs" align="center">
            <Text size="sm" c="rgba(255,255,255,0.7)">
                Signed in as
            </Text>
            {isLoading ? (
                <Skeleton height={16} width={140} />
            ) : (
                <Text size="sm" c="white" fw={500} data-testid="SignedInEmail">
                    {identity?.email ?? 'unknown'}
                </Text>
            )}
        </Group>
    );
};
